import { useQuery } from '@tanstack/react-query';
import { ApplogLevel } from 'src/api/FiretrolApiClient';
import { applogsApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export interface ApplogsParams {
  windowMinutes: number;
  minLevel: ApplogLevel;
  search?: string;
  limit?: number;
}

export function useApplogs({
  windowMinutes,
  minLevel,
  search,
  limit,
}: ApplogsParams) {
  return useQuery({
    queryKey: queryKeys.applogs.query({
      windowMinutes,
      minLevel,
      search,
      limit,
    }),
    queryFn: ({ signal }) =>
      applogsApiClient.queryApplogs(
        windowMinutes,
        minLevel,
        search,
        limit,
        toCancelToken(signal),
      ),
    meta: { errorContext: 'application logs' },
  });
}
